import _ from 'underscore';

import { Popup } from '../models/Popup';
import { StackedElementsService } from '../services/StackedElementsService';

export  interface IPopupScope extends ng.IScope {
  show: boolean;
  positionCorner: string;
  contentCorner: string;
  getPositionElement: () => JQuery;
}

export class PopupCtrl {

  public static $inject = [
    '$scope',
    '$element',
    '$transclude'
  ];

  public popup: Popup;

  private scope: IPopupScope;
  $onInit: () => void;
  constructor($scope: IPopupScope, $element: JQuery, $transclude: (cloneFn: (clone: JQuery) => any) => any) {
    this.$onInit = () => {
      this.scope = $scope;
      const getPositionElement = () => {
        return _.isFunction($scope.getPositionElement) ? $scope.getPositionElement() : $element;
      };
      this.popup = new Popup(getPositionElement, () => $transclude((clone: JQuery) => clone), StackedElementsService.instance);
    };
  }

  public hidePopup(): void {
    this.scope.show = false;
  }

}
